import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { isDate as yt } from "../../util/code-utils.js";
import { convertMsToSeconds as l, dateFromUnixTimestamp as h, secondsAgo as Ht, secondsInTheFuture as Ut } from "../../util/date-utils.js";

var kt = /*#__PURE__*/function () {
  function kt(t, s, e, i) {
    _classCallCheck(this, kt);

    this.Xl = t, this.Yl = s, this.comparator = e, this.Zl = i, this.Yl === kt.Th.Eh && this.comparator !== kt._h.Ah && this.comparator !== kt._h.yh && this.comparator !== kt._h.Sh && this.comparator !== kt._h.Nh && (this.Zl = h(this.Zl));
  }

  _createClass(kt, [{
    key: "Ql",
    value: function Ql(t) {
      var s = null;

      switch (null != t && (s = t[this.Xl]), this.comparator) {
        case kt._h.Mh:
          return null != s && s.valueOf() === this.Zl.valueOf();

        case kt._h.Rh:
          return null == s || s.valueOf() !== this.Zl.valueOf();

        case kt._h.Hh:
          return typeof s == typeof this.Zl && s > this.Zl;

        case kt._h.Ah:
          return this.Yl === kt.Th.Eh ? null != s && yt(s) && Ht(s) <= this.Zl : typeof s == typeof this.Zl && s >= this.Zl;

        case kt._h.Lh:
          return typeof s == typeof this.Zl && s < this.Zl;

        case kt._h.yh:
          return this.Yl === kt.Th.Eh ? null != s && yt(s) && Ht(s) >= this.Zl : typeof s == typeof this.Zl && s <= this.Zl;

        case kt._h.Ih:
          return null != s && "string" == typeof s && typeof s == typeof this.Zl && null != s.match(this.Zl);

        case kt._h.Oh:
          return null != s;

        case kt._h.Uh:
          return null == s;

        case kt._h.Sh:
          return null != s && yt(s) && Ut(s) < this.Zl;

        case kt._h.Nh:
          return null != s && yt(s) && Ut(s) > this.Zl;

        case kt._h.Dh:
          return null == s || typeof s != typeof this.Zl || "string" != typeof s || null == s.match(this.Zl);
      }

      return !1;
    }
  }, {
    key: "ss",
    value: function ss() {
      var t = this.Zl;
      return yt(this.Zl) && (t = l(t.valueOf())), {
        k: this.Xl,
        t: this.Yl,
        c: this.comparator,
        v: t
      };
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new kt(t.property_key, t.property_type, t.comparator, t.property_value);
    }
  }, {
    key: "yn",
    value: function yn(t) {
      return new kt(t.k, t.t, t.c, t.v);
    }
  }]);

  return kt;
}();

export { kt as default };
kt._h = {
  Mh: 1,
  Rh: 2,
  Hh: 3,
  Ah: 4,
  Lh: 5,
  yh: 6,
  Ih: 10,
  Oh: 11,
  Uh: 12,
  Sh: 15,
  Nh: 16,
  Dh: 17
}, kt.Th = {
  Qh: "boolean",
  Xh: "number",
  Bh: "string",
  Eh: "date"
};